import MultChoiceObj from "../Models/QTypes/MultChoiceObj";
// import CheckboxObj from '../Models/QTypes/CheckboxObj';

const Workforce_QSet = [
  new MultChoiceObj({
    questionSet: {
      English: "How does your analytics sync with your source HCM system?",
    },
    answerSet: {
      English: [
        "Standard reporting does not keep in sync but can be updated as needed.",
        "Manual updates are scheduled to update standard reports.",
        "New data can be automatically captured, but we still need manual updates to the analytics layer.",
        "Fully integrated analytic systems allow us to analyze new data and capabilities immediately.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "How do you incorporate survey data to enrich HR processes?",
    },
    answerSet: {
      English: [
        "Manual survey data collected in spreadsheets.",
        "Annual HR survey results displayed in shared BI tools.",
        "Standard BI Dashboards includes HR Survey results.",
        " Survey and sentiment analysis of workforce tone is integrated into our analytics system.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "How do you report on employee skill development?",
    },
    answerSet: {
      English: [
        "Only assessed in annual survey and review processes.",
        "We track strengths & weaknesses but can't easily ID potential skill gaps.",
        "We report on workers' competencies and identify skill gaps as needed.",
        "We visually correlate talent to roles, assess performance & identify matches.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "How do you track employee career mobility?",
    },
    answerSet: {
      English: [
        "We report on individual career moves in annual review discussions.",
        "Department managers track employee mobility as needed.",
        "Corporate historical employee moves reported in our HCM system.",
        " Top internal mobility factors are tracked at the employee level with Analytics.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English:
        "Which best describes how you analyze workforce retention and measure joiners & leavers?",
    },
    answerSet: {
      English: [
        "Our process uses spreadsheet reports for tracking attrition and retention.  predict future attrition rates.",
        "Turnover and retention reports are created in standard BI tools .",
        "Attrition is tracked with our HCM system dashboards.",
        "Analytics system visualizes turnover drivers, with embedded ML to predict future attrition rates.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "How do you forecast labor availability?",
    },
    answerSet: {
      English: [
        "We use spreadsheets to track availability and absences.",
        "Labor forecasts are in standard shared BI reports.",
        "Partially integrated forecasting done in dashboards based on past trend.",
        "Fully streamlined labor forecasting with predictive analytics and what-if scenario modeling.",
      ],
    },
  }),
];

export default Workforce_QSet;
